import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

const CustomDropdown = ({
  name,
  value,
  onChange,
  options,
  className = "form-control",
  style = {},
  disabled = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selectedOption = options.find(opt => opt.value === value) || options[0];

  return (
    <div ref={dropdownRef} style={{ position: 'relative', width: '100%', ...style }}>
      <div
        className={`${className} custom-dropdown-trigger`}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.6 : 1,
          userSelect: 'none',
          backgroundColor: isOpen ? 'var(--bg-hover, #f9fafb)' : 'var(--bg-card, #ffffff)'
        }}
        onClick={() => !disabled && setIsOpen(!isOpen)}
      >
        <span>{selectedOption ? selectedOption.label : ''}</span>
        <ChevronDown size={16} style={{ 
          color: 'var(--accent, #0793A7)', 
          transform: isOpen ? 'rotate(180deg)' : 'none',
          transition: 'transform 0.2s ease',
          marginLeft: '8px'
        }} />
      </div>

      {isOpen && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          marginTop: '4px',
          backgroundColor: 'var(--bg-card, #ffffff)',
          border: '1px solid var(--border, #e5e7eb)',
          borderRadius: '8px',
          boxShadow: 'var(--shadow-md, 0 4px 6px -1px rgba(0, 0, 0, 0.1))',
          zIndex: 1000,
          overflow: 'hidden'
        }}>
          {options.map((opt) => (
            <div
              key={opt.value}
              style={{
                padding: '10px 14px',
                cursor: 'pointer',
                backgroundColor: opt.value === value ? 'var(--info-bg, #e6f6f8)' : 'transparent',
                color: opt.value === value ? 'var(--accent-dark, #066478)' : 'var(--text-primary, #111111)',
                fontWeight: opt.value === value ? '600' : '400',
                transition: 'background-color 0.15s ease',
                userSelect: 'none',
                fontSize: '14px'
              }}
              onMouseEnter={(e) => {
                if (opt.value !== value) {
                  e.currentTarget.style.backgroundColor = 'var(--bg-hover, #f9fafb)';
                }
              }}
              onMouseLeave={(e) => {
                if (opt.value !== value) {
                  e.currentTarget.style.backgroundColor = 'transparent';
                }
              }}
              onClick={() => {
                const dummyEvent = { target: { name, value: opt.value } };
                onChange(dummyEvent);
                setIsOpen(false);
              }}
            >
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
